import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../../Formik'
import { RadioGroup } from '../../../../Radio'
import {
  QA_NAME_VIEWING_FORM_MODE,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { getViewingFormModeOptions } from '../../RentalPortalViewingFormModal.utils'
import { useViewingFormChangeFields } from '../RentalPortalViewingFormModalFields.hooks'

import * as styles from './ViewingFormModeField.module.css'

function ViewingFormModeField() {
  const { t } = useTranslation()

  const { handleChangeMode } = useViewingFormChangeFields()

  return (
    <FormikField
      Component={RadioGroup}
      className={styles.ViewingFormModeField}
      name={VIEWING_FORM_FIELD_NAME.mode}
      options={getViewingFormModeOptions(t)}
      qaName={QA_NAME_VIEWING_FORM_MODE}
      onChange={handleChangeMode}
    />
  )
}

export default ViewingFormModeField
